import { Link } from "gatsby";
import React from "react";
import { useEffect, useState } from "react";

import {
  subNavs_container,
  active,
  subNav_stuck,
  navLinks,
} from "./SubNav.module.scss";

const SubNav = ({ navArray, currentPath }) => {
  const [isStuck, setIsStuck] = useState(false);
  const ref = React.createRef();

  useEffect(() => {
    const cachedRef = ref.current;
    const observer = new IntersectionObserver(
      ([e]) => setIsStuck(e.intersectionRatio < 1),
      { threshold: [1] }
    );
    observer.observe(cachedRef);
    return () => observer.unobserve(cachedRef);
  }, [ref]);

  const stickyClass = isStuck ? subNav_stuck : "";

  return (
    <section
      className={`${subNavs_container} ${stickyClass}`}
      id="subNavigation"
      ref={ref}
    >
      <ul role="list">
        {navArray.map(({ name, path }, index) => {
          return (
            <li key={index} className={`${path === currentPath && active}`}>
              <Link className={navLinks} to={path}>
                {name}
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default SubNav;
